var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fill-height":"","fluid":"","grid-list-sm":""}},[_c('v-layout',[_c('v-flex',{attrs:{"md12":"","lg12":""}},[_c('Reservas')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }